
$soupmail.control.grid = function($config) {
	
	this.config = {
		selector : '.grid',
		model : '',
		listArrayKey : '',
		columns : [
			{ name:'id', label:'ID', cssclass:'id', layout:'' },
			{ name:'name', label:'Title', cssclass:'name', layout:'' }
		],
		noResultsMessage : 'No items found.',
		editingEnabled : false,
		deletingEnabled : false,
		headersEnabled : true,
		paginationEnabled : false,
		paginationStartIndex : 0,
		paginationFrameSize : 100,
		orderingEnabled : false,
		orderingColumn : '',
		orderingDirection : 'desc',
		searchEnabled : false,
		searchControl : '#searchbox',
		searchKeywords : '',
		searchModeAJAX : false,
		searchRequestDelay : 100,  // # of milliseconds
		onBeforeSearch : '',
		onChange : '',
		dataWrapperElem : 'table',
		dataRowElem : 'tr',
		dataHeaderRowClass : 'row-header',
		dataHeaderElem : 'th',
		dataItemRowId : '',
		dataItemRowClass : '',
		dataItemElem : 'td',
		dataItemsWrapperStart : '',
		dataItemsWrapperEnd : ''
	};
	
	this.items = {};
	this.totalResultCount = 0;
	this.destroy = destroy;
	this.reset = reset;
	this.size = size;
	this.load = load;
	this.beforeSearch = beforeSearch;
	this.change = change;
	this.render = render;
	this.renderHeaderRow = renderHeaderRow;
	this.renderItemRow = renderItemRow;
	this.changeItem = changeItem;
	this.removeItem = removeItem;
	this.reorder = reorder;
	this.toggleDirection = toggleDirection;
	this.filter = filter;
	this.search = search;
	this.simpleSearch = simpleSearch;
	this.ajaxSearch = ajaxSearch;
	this.pageDown = pageDown;
	this.showAll = showAll;
	this.hideAll = hideAll;
	
	if ($config) {
		var grid = this;
		jQuery.each($config, function($key, $val) {
			grid.config[$key] = $val;
		});
	}
	
	if ($config.paginationEnabled) {
		var grid = this;
		jQuery(window).scroll(function(){
			//console.log('current: '+(jQuery(window).scrollTop()+jQuery(window).height()) + ' / '+(jQuery('#body-container').height() - 100)+ ' / '+($models.folders.isAjaxRequestInProgress() ? 'yes' : 'no'));
			var currentScrollHeight = (jQuery(window).scrollTop() + jQuery(window).height());
			var paginationTriggerHeight = (jQuery('#body-container').height() - 100);
			if ((currentScrollHeight > paginationTriggerHeight) && !$models[grid.config.model].isAjaxRequestInProgress() && !$views.foldermanager.currentSearchTerm && (grid.totalResultCount > grid.config.paginationFrameSize) && (grid.totalResultCount > (grid.config.paginationStartIndex + grid.config.paginationFrameSize))) {
				console.log('USER SCROLLED TO BOTTOM OF LIST - NOW LOADING MORE ITEMS INTO GRID');
				grid.pageDown();
			}
		});
	}
	
	if (this.config.searchEnabled) {
		var grid = this;
		jQuery(this.config.searchControl).keyup(function() {
			grid.beforeSearch();
			grid.search(jQuery(this).val());
		});
	}
	
	function destroy() {
		jQuery(window).unbind('scroll');
	};
	
	function reset() {
		this.items = {};
	};
	
	function size() {
		return this.items.length;
	};
	
	function load($callback) {
		var grid = this;
		var params = {};
		if (this.config.paginationFrameSize > 0) {
			params.max_results = this.config.paginationFrameSize;
		}
		if (this.config.paginationEnabled && (this.config.paginationStartIndex > 0)) {
			params.offset = this.config.paginationStartIndex;
		}
		if (this.config.orderingEnabled && (this.config.orderingColumn != '')) {
			params.sort_by = this.config.orderingColumn;
			params.sort_direction = this.config.orderingDirection.toLowerCase();
		}
		if (this.config.searchEnabled && this.config.searchKeywords) {
			params['filters[keywords]'] = this.config.searchKeywords;
		}
		$models[this.config.model].getListWithOffset(params, function($data) {
			grid.orderedItems = $data[grid.config.listArrayKey];
			for (var i in grid.orderedItems) {
				var item = grid.orderedItems[i];
				item._visible = true;
				grid.items['item'+item.id] = item;
			}
			grid.render();
			grid.change();
			if (typeof($callback) == 'function') {
				$callback();
			}
		});
	};
	
	function beforeSearch($func) {
		if (typeof($func) == 'function') {
			this.config.onBeforeSearch = $func;
		} else if (typeof(this.config.onBeforeSearch) == 'function') {
			this.config.onBeforeSearch();
		}
	};
	
	function change($func) {
		if (typeof($func) == 'function') {
			this.config.onChange = $func;
		} else if (typeof(this.config.onChange) == 'function') {
			this.config.onChange();
		}
	};
	
	function render() {
		var html = '<'+this.config.dataWrapperElem+'>';
		if (this.config.headersEnabled) {
			html += this.renderHeaderRow() + "\r\n";
		}
		if (this.config.dataItemsWrapperStart) {
			html += this.config.dataItemsWrapperStart + "\r\n";
		}
		if (jQuery.objectSize(this.items) > 0) {
			for (var i in this.items) {
				if (this.items[i]._visible) {
					html += '<'+this.config.dataRowElem+(this.config.dataItemRowId ? ' id="'+this.config.dataItemRowId.replace('{id}', this.items[i].id)+'"' : '')+' class="'+(this.config.dataItemRowClass ? this.config.dataItemRowClass + ' ' : '') + (this.items[i]._isNewPrependedFolder ? 'is-new-prepended-folder ' : '') +'row-'+this.items[i].id + '" data-id="'+this.items[i].id+'"></'+this.config.dataRowElem+'>';
				}
			}
		} else if (this.config.noResultsMessage) {
			html += '<'+this.config.dataRowElem+' class="'+(this.config.dataItemRowClass ? this.config.dataItemRowClass + ' ' : '') + 'row-0 grid-no-results" data-id="0"><'+this.config.dataItemElem+' class="no-results-found">'+this.config.noResultsMessage+'</'+this.config.dataItemElem+'></'+this.config.dataRowElem+'>';
		}
		if (this.config.dataItemsWrapperEnd) {
			html += this.config.dataItemsWrapperEnd + "\r\n";
		}
		html += '</'+this.config.dataWrapperElem+'>';
		jQuery(this.config.selector).html(html);
		for (var i in this.items) {
			if (this.items[i]._visible) {
				this.renderItemRow(this.items[i]);
			}
		}
		if (this.config.orderingEnabled) {
			var grid = this;
			jQuery(this.config.selector).find('.orderable').click(function() {
				grid.reorder(jQuery(this).attr('data-ordering'), jQuery(this).attr('data-ordering-direction'));
			});
		}
	};
	
// NOTE: this can be overridden to point to a function inside a view.... if necessary
	function renderHeaderRow() {
		var row = '<'+this.config.dataRowElem+' class="'+this.config.dataHeaderRowClass+'">';
		for (var i=0; i < this.config.columns.length; i++) {
			var ordering = (this.config.columns[i].ordering ? this.config.columns[i].ordering : this.config.columns[i].name);
			var cssClass = this.config.columns[i].cssclass;
			var attributes = '';
			if (this.config.orderingEnabled && ordering && (ordering != 'disabled')) {
				cssClass = (cssClass ? cssClass + ' ' : '');
				cssClass += 'orderable';
				attributes += ' data-ordering="'+ordering+'"';
				if (this.config.columns[i].forceOrderingDirection) {
					attributes += ' data-ordering-direction="'+this.config.columns[i].forceOrderingDirection+'"';
				}
			}
			if (this.config.orderingEnabled && ordering && (ordering == this.config.orderingColumn)) {
				if (this.config.orderingDirection == 'asc') {
					cssClass += ' orderAscending';
				} else {
					cssClass += ' orderDescending';
				}
			}
			if (!this.config.columns[i].hidden) {
				if (this.config.dataHeaderRowClass == 'toolbar') {
					row += '<'+this.config.dataHeaderElem+' title="'+this.config.columns[i].tipsy+'" rel="tipsy" class="'+cssClass+'"'+attributes+'>'+this.config.columns[i].label+'</'+this.config.dataHeaderElem+'>';
				} else {
					row += '<'+this.config.dataHeaderElem+' class="'+cssClass+'"'+attributes+'>'+this.config.columns[i].label+'</'+this.config.dataHeaderElem+'>';
				}
			}
		}
		row += '</'+this.config.dataRowElem+'>';
		return row;
	};
	
// NOTE: this can be overridden to point to a function inside a view.... if necessary
	function renderItemRow($item) {
		var row = '';
		for (var i=0; i < this.config.columns.length; i++) {
			var columnVisible = !this.config.columns[i].hidden;
			if (
			  (!this.config.editingEnabled && (this.config.columns[i].name == 'edit')) ||
			  (!this.config.editingEnabled && (this.config.columns[i].name == 'reset')) ||
			  (!this.config.deletingEnabled && (this.config.columns[i].name == 'delete')) ||
			  ((this.config.columns[i].name == 'edit') && ($item._editable === false)) ||
			  ((this.config.columns[i].name == 'delete') && ($item._editable === false)) ||
			  ((this.config.columns[i].name == 'reset') && ($item._editable === false))
			) {
				columnVisible = false;
			}
			if (columnVisible) {
				var data = (this.config.columns[i].layout ? this.config.columns[i].layout : '{'+this.config.columns[i].name.replace('.', '_')+'}').replace(/{/gi, '<span class="data_').replace(/}/gi, '"></span>');
				var itemElem = (this.config.columns[i].elementName ? this.config.columns[i].elementName : this.config.dataItemElem);
				row += '<'+itemElem+' class="'+this.config.columns[i].cssclass+'">'+data+'</'+itemElem+'>';
			}
		}
		var thisRowDOMobject = jQuery(this.config.selector).find('.row-'+$item.id);
		thisRowDOMobject.html(row);
		for (var i=0; i < this.config.columns.length; i++) {
			if (!this.config.columns[i].defaultvalue) {
				this.config.columns[i].defaultvalue = '---';
			}
			var name = this.config.columns[i].name;
			if (name) {
				var value = ($item[name] ? $item[name] : this.config.columns[i].defaultvalue);
				if (name.indexOf('.') > 0) {
					var nameParts = name.split('.');
					var namePartsParent = nameParts[0];
					var namePartsChild = nameParts[1];
					value = ($item[namePartsParent] ? $item[namePartsParent][namePartsChild] : this.config.columns[i].defaultvalue);
				}
				if (typeof(this.config.columns[i].onBeforeRender) == 'function') {
					value = this.config.columns[i].onBeforeRender(value, $item);
				}
				thisRowDOMobject.find('span.data_'+name.replace('.', '_')).text(value);
			}
			if (typeof(this.config.columns[i].onAfterRender) == 'function') {
				this.config.columns[i].onAfterRender($item, thisRowDOMobject);
			}
		}
		return row;
	};
	
	function changeItem($id, $item) {
		if (!this.items['item'+$id]) {
			this.items['item'+$id] = {};
		}
		for (var $key in $item) {
			this.items['item'+$id][$key] = $item[$key];
		}
		this.renderItemRow(this.items['item'+$id]);
		this.change();
	};
	
	function removeItem($id) {
		delete this.items['item'+$id];
		jQuery(this.config.selector).find('.row-'+$id).fadeOut('slow');
	};
	
	function reorder($columnName, $direction) {
		if (this.config.orderingEnabled) {
			if (!$direction && (this.config.orderingColumn == $columnName)) {
				this.toggleDirection();
			} else {
				this.config.orderingDirection = ($direction ? $direction : 'asc');
			}
			this.config.orderingColumn = $columnName;
			this.config.paginationStartIndex = 0;
			this.reset();
			this.load();
		}
	};
	
	function toggleDirection() {
		if (this.config.orderingDirection == 'desc') {
			this.config.orderingDirection = 'asc';
		} else if (this.config.orderingDirection == 'asc') {
			this.config.orderingDirection = 'desc';
		} else {
			this.config.orderingDirection = 'asc';
		}
	};
	
	function filter() {
		// todo
	};
	
	function search($keywords) {
		if (this.config.searchEnabled) {
			if (this.config.searchModeAJAX) {
				this.ajaxSearch($keywords);
			} else {
				this.simpleSearch($keywords);
			}
		}
	};
	
	function simpleSearch($keywords) {
		if (!$keywords) {
			this.showAll();
		} else {
			jQuery.each(this.items, function($key, $val) {
				if ($val.toString().indexOf($keywords) >= 0) {
					this.items[$key]._visible = true;
				} else {
					this.items[$key]._visible = false;
				}
			});
		}
		this.render();
		this.change();
	};
	
	function ajaxSearch($keywords) {
		var grid = this;
		function runAjaxSearch() {
			grid.config.paginationStartIndex = 0;
			grid.config.searchKeywords = $keywords;
			grid.reset();
			grid.load();
		}
		if ($keywords && ($keywords != this.config.searchKeywords)) {
			clearTimeout(this.searchTimer);
			this.searchTimer = setTimeout(runAjaxSearch, this.config.searchRequestDelay);
		} else if (!$keywords) {
			runAjaxSearch();
		}
	};
	
	function pageDown() {
		this.config.paginationStartIndex += this.config.paginationFrameSize;
		this.load();
	};
	
	function showAll($visibility) {
		if (typeof($visibility) != 'boolean') {
			$visibility = true;
		}
		jQuery.each(this.items, function($key, $val) {
			this.items[$key]._visible = $visibility;
		});
		this.render();
		this.change();
	};
	
	function hideAll() {
		this.showAll(false);
	};
	
};



// WEBPACK FOOTER //
// ./src/js/helpers/soupmail.control.grid.js